import { useTranslation } from 'react-i18next';

export default function ProductGallery() {
  const { t } = useTranslation();

  const image1 = `https://readdy.ai/api/search-image?query=Premium%20limited%20edition%20designer%20sneakers%20on%20warm%20sand%20colored%20paper%20texture%2C%20minimal%20editorial%20style%2C%20soft%20golden%20hour%20light%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20elevated%20fashion%20photography%2C%20subtle%20film%20grain&width=600&height=750&seq=gallery-v2-sneakers-f1a2&orientation=portrait`;

  const image2 = `https://readdy.ai/api/search-image?query=Trendy%20oversized%20graphic%20hoodie%20laid%20flat%20on%20warm%20oatmeal%20linen%20backdrop%2C%20minimal%20editorial%20composition%2C%20soft%20natural%20daylight%2C%20clean%20streetwear%20photography%2C%20warm%20neutral%20palette%2C%20urban%20fashion%20aesthetic&width=600&height=750&seq=gallery-v2-hoodie-b3c4&orientation=portrait`;

  const image3 = `https://readdy.ai/api/search-image?query=Elegant%20black%20leather%20crossbody%20bag%20on%20warm%20cream%20ceramic%20surface%2C%20soft%20natural%20window%20light%2C%20minimal%20editorial%20style%2C%20clean%20product%20photography%2C%20warm%20neutral%20background%2C%20luxury%20simplicity&width=600&height=750&seq=gallery-v2-bag-d5e6&orientation=portrait`;

  const image4 = `https://readdy.ai/api/search-image?query=Minimal%20gold%20jewelry%20set%20with%20bracelet%20and%20ring%20on%20warm%20beige%20velvet%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20elegant%20composition%2C%20warm%20neutral%20background%2C%20refined%20aesthetic&width=600&height=750&seq=gallery-v2-accessories-f7g8&orientation=portrait`;

  const products = [
    { image: image1, category: 'Sneakers' },
    { image: image2, category: 'Streetwear' },
    { image: image3, category: 'Bolsas' },
    { image: image4, category: 'Acessórios' },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-400 font-semibold mb-3">
            {t('gallery.label')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading">
            <span className="font-bold text-foreground-950">{t('gallery.title')} </span>
            <span className="italic font-medium text-foreground-700">{t('gallery.title_italic')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {products.map((product, i) => (
            <div
              key={i}
              className="group bg-background-200/60 rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={product.image}
                  alt={`${product.category} Planilha CSSBuy`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 bg-white">
                <p className="text-xs text-foreground-400 uppercase tracking-wide">{product.category}</p>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1 mt-1 text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  {t('gallery.view_link')}
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}